// © Microsoft Corporation. All rights reserved.

import { neutralLayerCardContainer, neutralOutlineRest } from "@microsoft/fast-components-styles-msft";

export const DisabledMessageStyles = {

    disabledMessageContainer: {
        display: "block",
        margin: "16px 0",
        padding: "12px !important",
        "border-radius": "8px",
        background: neutralLayerCardContainer,
        "text-align": "center",

        "& .cwt-icon.cwt-disabled-message": {
            display: "inline",
            color: neutralOutlineRest,
            fill: "#ff0000",
            opacity: "1",

            "& .cwt-icon-vector": {
                margin: "-4px 8px 0",
                display: "inline-flex",
                "vertical-align": "middle"
            }
        }
    }
};